import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SnakeEyeTonguePiercingImage from '../../Assets/Piercing Services/snake eye tongue piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SnakeEyeTonguePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Snake Eye Tongue Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Snake Eye Tongue Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Snake Eye Tongue Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SnakeEyeTonguePiercingImage} alt="Snake Eye Tongue Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Snake Eye Tongue Piercing</h3>

          <p>
            Make a bold and unforgettable statement with our professional snake eye tongue piercing services in the UAE, available at an affordable price of 250 AED. Snake eye tongue piercing is a daring and eye-catching style that runs horizontally through the tip of the tongue, creating the striking appearance of two “eyes,” similar to a snake’s gaze. This unique and modern piercing is perfect for individuals who want to stand out and express their individuality with confidence. Its edgy look and dynamic visibility make it a popular choice among those who love bold body art and contemporary piercing trends.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each snake eye tongue piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Tongue piercings require advanced expertise due to the sensitivity of the area, and our experienced specialists are trained to perform the procedure carefully while minimizing discomfort and ensuring accurate placement.
          </p>

          <p>
            Snake eye tongue piercing is ideal for individuals who want a bold and expressive look that truly stands out. Its placement at the tip of the tongue creates a dramatic visual effect, especially when speaking, smiling, or laughing. This piercing can be styled with a variety of jewelry options such as barbells with decorative ends, allowing you to customize your look to match your personal style. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options that suit your comfort and aesthetic goals.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support efficient healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that tongue piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your snake eye tongue piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions such as avoiding certain foods and habits during the healing period. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our snake eye tongue piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted snake eye tongue piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and daring look effortlessly. Book your snake eye tongue piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Snake Eye Tongue Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SnakeEyeTonguePiercing;